import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const Table = dynamic(() => import('./Table').then((m) => ({ default: m.Table })));

Builder.registerComponent(Table, {
  name: 'Table',
  inputs: [
    {
      name: 'rows',
      type: 'list',
      subFields: [
        {
          name: 'column',
          type: 'list',
          subFields: [
            {
              name: 'cell',
              type: 'richText',
            },
          ],
        },
      ],
    },
  ],
});
